<div [id]="id" tabindex="-1" class="fixed top-0 left-0 right-0 z-50 hidden w-full p-4 overflow-x-hidden overflow-y-auto md:inset-0 h-[calc(100%-1rem)] max-h-full">
    <div class="relative w-96 max-h-full rounded-lg max-w-[343px]">
        <div class="relative bg-primary-purple-light-2 rounded-lg shadow p-6">
            <form #form novalidate (ngSubmit)="onSubmit()">
                <div class="flex flex-row justify-between items-center">
                    <h3 class="w-full text-xl font-bold text-primary-purple">{{ literalService.get('users.roadmaps.title', true) }}</h3>
                    <button (click)="modal.hide()" type="button" class="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-lg w-8 h-8 ml-auto inline-flex justify-center items-center dark:hover:bg-gray-600 dark:hover:text-white">
                        <img [src]="images.close" class="h-6 w-6" />
                    </button>
                </div>
                <p class="w-full whitespace-pre-line text-base pt-6 pb-6">
                    {{ literalService.get('users.roadmaps.description', true) }}
                </p>
                <div class="flex mb-2">
                    <img [src]="images.booking.date" alt="date" class="h-6 w-6 mr-2" />
                    <label class="font-normal text-base">{{ literalService.get("users.roadmaps.date", true) }}</label>
                </div>
                <app-calendar [title]="literalService.get('users.roadmaps.date', true)" [value]="date" [allDays]="true" [showOnTop]="true" [hideCalendar]="false" (change)="changeDate($event)" [placeholder]="literalService.get('users.roadmaps.date', true)" />
                <div class="mt-4">
                    <label class="font-normal text-base">{{ literalService.get('users.roadmaps.version', true) }}</label>
                    @if (availableVersions.length) {
                        <select [(ngModel)]="selectedVersion" [ngModelOptions]="{standalone: true}" class="block w-full px-3 py-2 mt-1 bg-white border rounded-s rounded-e text-base font-normal focus:outline-none">
                            @for (documentVersion of availableVersions; track documentVersion.version) {
                                <option [ngValue]="documentVersion.version">
                                    {{ 'v' + documentVersion.version + ' - ' + moment.utc(documentVersion.createdAt).local().format('DD/MM/YYYY HH:mm') }}
                                </option>
                            }
                        </select>
                    } @else {
                        <p class="text-sm text-slate-400 mt-1">{{ literalService.get('users.roadmaps.noVersions', true) }}</p>
                    }
                </div>
                <div class="flex justify-center items-center mt-8">
                    <button type="button" class="secondary mt-2 mr-5 gap-4 p-2 border-2 font-semibold w-full uppercase cursor-pointer" (click)="modal.hide()">{{ literalService.get('cancel', true) }}</button>
                    <button type="submit" class="primary mt-2 gap-4 p-2 border-2 font-semibold w-full uppercase cursor-pointer text-white" [disabled]="!date || loading || selectedVersion === null">{{ literalService.get('users.roadmaps.download', true) }}</button>
                </div>
            </form>
        </div>
    </div>
</div>
